"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountPageView = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerAccountPageView(breadcrumbs, contentSubType) {
    const categoryTree = breadcrumbs.map(i => i.toLowerCase().replace(' ', '-')).join(' > ');
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_page_view',
        content: 'Customer Account',
        content_subtype: contentSubType,
        login_state: true,
        categoryTree,
        categoryTreeDisplayName: breadcrumbs.join(' > '),
    });
}
exports.trackCustomerAccountPageView = trackCustomerAccountPageView;
//# sourceMappingURL=trackCustomerAccountPageView.js.map